import type { ReactNode } from 'react';
import { useFeatureFlags } from '../context';

interface FeatureFlagGateProps {
  /** Flag key to evaluate. */
  flag: string;
  /** Rendered while the flags are still resolving — avoids flashing the disabled state. */
  pending?: ReactNode;
  /** Rendered when the flag is off. */
  fallback?: ReactNode;
  children: ReactNode;
}

/**
 * Renders its children only while the given flag is enabled.
 * Use for whole routes; for inline conditions prefer `useFeatureFlag`.
 */
export function FeatureFlagGate({
  flag,
  pending = null,
  fallback = null,
  children
}: FeatureFlagGateProps) {
  const { isEnabled, isReady } = useFeatureFlags();

  if (!isReady) {
    return <>{pending}</>;
  }

  return <>{isEnabled(flag) ? children : fallback}</>;
}
